import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function Login() {
  const { user, loading, signIn } = useAuth();
  if (loading) return <div className="loading">Loading…</div>;
  if (user) return <Navigate to="/app" replace />;
  return (
    <div className="login">
      <div className="login-card">
        <h1>Sauntera Pins</h1>
        <p>Admin dashboard. Sign in with your authorized Google account.</p>
        <button className="primary" onClick={() => signIn()}>Sign in with Google</button>
      </div>
    </div>
  );
}
